app.controller(
    'SetTranslationController', ['$scope', '$rootScope', '$stateParams', '$translate', 'GroupService', 'HelperService', 'SideBarService', '$window', SetTranslationController]
);

function SetTranslationController($scope, $rootScope, $stateParams, $translate, GroupService, HelperService, SideBarService,$window) {
    var vm = this;
    vm.ActiveDescription = {};
    vm.ActiveDescriptionId = 0;
    vm.DescriptionToTranslate = {};
    vm.SelectedDescriptionStatusItem = {};
    vm.PreviousDescriptionStatusItem = {};

    vm.Group = {};
    vm.ActiveDescriptionVm =
        {
            Clients: [{ "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }],
            QualificationList: [{ "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }]
        };

    $scope.edit = {};
    $scope.item = {};

    $scope.contentTranslate = null;

    $scope.clients = [];
    $scope.classifications = [
    {
        name: 'Art moderne',
        checked: true
    },
    {
        name: 'Haute époque',
        checked: true
    }
    ];

    $scope.item.disaplayName = $scope.item.name || ($scope.item.firstName || $scope.item.lastName);

    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    $translate.use($rootScope.LangForInterface)

    if ($stateParams.id) {
        vm.ParamGroupId = $stateParams.id;
    }
    else {
        vm.ParamGroupId = 3;
    }

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = vm.ParamZoneId;

    if ($stateParams.qc) {
        vm.ParamQcId = $stateParams.qc;
    }
    else {
        vm.ParamQcId = 10585;
    }

    initController();

    function initController() {
        loadGroup(vm.ParamGroupId, vm.ParamQcId, $scope.CurrentLang, $rootScope.LangForTranslationDestination, $stateParams.index, $stateParams.sortKey, $stateParams.reverse);
    }

    function loadGroup(groupId, qc, lang, lang2, index, sortKey, reverse) {
        GroupService.GetGroup(groupId, qc, lang, lang2, index, sortKey, reverse)
            .then(function (group) {
                vm.Group = group;
                vm.GroupOrigin = angular.copy(vm.Group);
                if (vm.Group.DescriptionList.length > 0) {
                    vm.ActiveDescriptionId = 0;
                    vm.ActiveDescription = vm.Group.DescriptionList[vm.ActiveDescriptionId];

                    //load descriptionVm
                    vm.GetDescriptionVm();

                    //load translation description
                    vm.GetDescriptionTranslated();
                }

                $rootScope.Clients = group.ClientList;
                $rootScope.Comments = group.CommentList;
                $rootScope.SideBar = group.SideBar;

                $rootScope.CurrentObjectId = groupId;
                $rootScope.CurrentPageType = $rootScope.EnumLinkType.Group;
                $rootScope.CurrentObjectStatus = group.CurrentGroupStatus;
                $rootScope.SideBar.CurrentObjectStatus = group.CurrentGroupStatus;
                $rootScope.SideBar.StatusList = $rootScope.StatusList4WorkflowObjectSt;                

                vm.GetAssociatedPlacesOnSideBar();
                vm.GetAssociatedZonesOnSideBar();
                //$scope.ChangeZoneById(vm.ParamZoneId);
            });
    }

    vm.UpdateGroup = function () {
        GroupService.UpdateGroup(vm.Group.Group)
            .then(function (data) {


            });
    }

    vm.TranslateGroup = function () {
        if ((vm.Group.GroupToTrans.GroupTitle != undefined) && (vm.Group.GroupToTrans.GroupTitle.length > 0))
        GroupService.TranslateGroup(vm.Group.GroupToTrans)
            .then(function (data) {


            });
    }

    vm.UpdateDescription = function () {
        if (vm.SelectedDescriptionStatusItem != undefined) {
            vm.DescriptionToTranslate.StatusId = vm.SelectedDescriptionStatusItem.id;
        }
        else {
            vm.DescriptionToTranslate.StatusId = 17;
        }

        if (vm.NewDescription) {            
            HelperService.AddDescription(vm.DescriptionToTranslate)
            .then(function (data) {
                vm.NewDescription = !$rootScope.NewDescriptionTranslationIsAdded;                
            });            
        }
        else {
            HelperService.UpdateDescription(vm.DescriptionToTranslate)
                .then(function (data) {

                });
        }
    }
    vm.OpenInOtherLang = function (lang) {
        $window.location.href = $rootScope.interfaceSubFolder +'/#!/traduction/set?id=' + vm.Group.GroupTrans.GroupId + "&lang=" + lang + "&index=" + $stateParams.index + "&sortKey=" + $stateParams.sortKey + "&reverse=" + $stateParams.reverse + "&z=" + $stateParams.z;
    }
    vm.UpdateDescriptionStatusId = function () {
        if (vm.SelectedDescriptionStatusItem != undefined) {
            vm.DescriptionToTranslate.StatusId = vm.SelectedDescriptionStatusItem.id;
        }
        else {
            vm.DescriptionToTranslate.StatusId = 17;
        }
        if (vm.NewDescription) {            
            HelperService.AddDescription(vm.DescriptionToTranslate)
            .then(function (data) {
                vm.NewDescription = !$rootScope.NewDescriptionTranslationIsAdded;
            });
        }
        else {
            if (vm.SelectedDescriptionStatusItem != vm.PreviousDescriptionStatusItem) {
                vm.PreviousDescriptionStatusItem = vm.SelectedDescriptionStatusItem;
                HelperService.UpdateDescription(vm.DescriptionToTranslate)
                    .then(function (data) {

                    });
            }
        }
    }

    vm.GetDescriptionTranslated = function () {
        HelperService.GetDescriptionById(vm.Group.DescriptionList[vm.ActiveDescriptionId].DescriptionId, $rootScope.LangForTranslationDestination)
                                .then(function (desc) {
                                    if (desc.success == false) {
                                        vm.DescriptionToTranslate = angular.copy(vm.Group.DescriptionList[vm.ActiveDescriptionId]);
                                        vm.DescriptionToTranslate.LanguageCode = $rootScope.LangForTranslationDestination;
                                        vm.DescriptionToTranslate.IsDefaultLang = false;
                                        vm.DescriptionToTranslate.DescriptionTitle = '';
                                        vm.DescriptionToTranslate.Stick = '';
                                        vm.DescriptionToTranslate.Resume = '';
                                        vm.DescriptionToTranslate.Description = '';
                                        vm.DescriptionToTranslate.StatusTrad = $translate.instant("StatusId25");
                                        //init status
                                        vm.SelectedDescriptionStatusItem = $rootScope.StatusList4WorkflowDescriptionTranslationIdValue[0];
                                        vm.PreviousDescriptionStatusItem = angular.copy(vm.SelectedDescriptionStatusItem);
                                        vm.NewDescription = true;

                                    }
                                    else {
                                        vm.DescriptionToTranslate = desc;
                                        vm.SelectedDescriptionStatusItem = GetItemByFieldName(vm.DescriptionToTranslate.StatusId, 'id', $rootScope.StatusList4WorkflowDescriptionTranslationIdValue)[0];   
                                        vm.PreviousDescriptionStatusItem = angular.copy(vm.SelectedDescriptionStatusItem);
                                        vm.NewDescription = false;
                                    }

                                });
    };

    $rootScope.refreshHistory = function refreshHistory() {
        var lastelement = $rootScope.SideBar.HistoryList == null ? null : $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "Group", (lastelement == null ? 0 : lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                  function success(data) {
                      if ($rootScope.returnNewHistory !== undefined)
                          $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);

                  },
                function error(data) {
                });
    };

    $rootScope.AddComment = function AddComment(CurrentObjectId) {

        promiseAddComment = SideBarService.AddComment(vm.Group.SideBar.CommentEdit, vm.Group.GroupTrans.GroupId, $stateParams.lang, $rootScope.EnumLinkType.Group);

        promiseAddComment
            .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                }
            );
    };

    $rootScope.SaveDiffuseur = function SaveDiffuseur() {

        SideBarService.SaveDiffuseur($rootScope.Clients, vm.Group.GroupTrans.GroupId, $stateParams.lang, $rootScope.EnumLinkType.Group);
    };

    vm.GetDescriptionVm = function () {
        HelperService.GetDescriptionVm(vm.Group.DescriptionList[vm.ActiveDescriptionId].DescriptionId, $scope.CurrentLang)
            .then(function (desc) {
                vm.ActiveDescriptionVm = desc;
            });
    }

    vm.GetAssociatedPlacesOnSideBar = function () {
        HelperService.GetAssociatedPlacesOnSideBar(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang, true)
            .then(function (data) {
                $rootScope.AssociatedPlaces = data;
            });
    }

    $rootScope.SaveAssociatedPlaces = function SaveAssociatedPlaces() {
        promiseAddComment = SideBarService.SaveAssociatedPlaces(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang, $rootScope.AssociatedPlaces);
    };

    vm.GetAssociatedZonesOnSideBar = function () {
        HelperService.GetAssociatedZonesOnSideBar(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang)
            .then(function (data) {
                $rootScope.AssociatedZones = data;
            });
    }

    $rootScope.SaveAssociatedZones = function SaveAssociatedZones() {
        promiseAddComment = SideBarService.SaveAssociatedZones(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang, $rootScope.AssociatedZones);
    };

    vm.PreviousDesc = function () {
        if (vm.Group.DescriptionList.length > 0 && vm.ActiveDescriptionId > 0) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId - 1;
            vm.GetDescriptionVm();
            vm.GetDescriptionTranslated();
        }
    }

    vm.NextDesc = function () {
        if (vm.Group.DescriptionList.length > 0 && vm.ActiveDescriptionId < vm.Group.DescriptionList.length - 1) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId + 1;
            vm.GetDescriptionVm();
            vm.GetDescriptionTranslated();
        }
    }

    // SideBar method
    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {
        SideBarService.UpdateObjectStatus(status, objectId, $scope.CurrentLang, $rootScope.EnumLinkType.Group);
    };

    $rootScope.SaveQualificationAssociees = function () {
        HelperService.SaveQualificationAssociees(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang, $rootScope.SideBar.QualificationList);
    }

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareInfoByDefaultMail('emailShareGroupPracticalInfo', $translate.instant('emailShareGroupPracticalInfo').replaceAll('&amp;', '&'), vm.Group);
    }

    $rootScope.shareFicheComplete = function () {
        $rootScope.shareInfoPratique();
    }
}